import { render, staticRenderFns } from "./DashboardCustomization.vue?vue&type=template&id=645461a0&scoped=true"
import script from "./DashboardCustomization.vue?vue&type=script&lang=js"
export * from "./DashboardCustomization.vue?vue&type=script&lang=js"
import style0 from "./DashboardCustomization.vue?vue&type=style&index=0&id=645461a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645461a0",
  null
  
)

export default component.exports